<script lang="ts">
  import {
    applyReducer,
    getFormImageVideoStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    IFormImageVideoNode,
    IMediaPaint,
    PartialNode,
  } from "@shared/common/node/type";
  import { getAspectRatioStyle } from "@shared/common/node/util";
  import type { VideoInfo } from "@shared/common/types/data-source";
  import { getDataSourceValue } from "@shared/common/utils/data-source";
  import { assertCondition, isObject } from "@shared/common/utils/value";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";
  import BackgroundVideo from "./background-video.svelte";

  const { reactionEventListener, dataMap } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormImageVideoNode>;

  let image: IMediaPaint | undefined = node.fills?.find(
    (fill): fill is IMediaPaint => fill.type === "IMAGE"
  );
  let isBackgroundVideo =
    node.fills && image?.visible && image?.video?.fileName;

  const videoInfoAssertion = assertCondition<VideoInfo[]>(
    (val): val is VideoInfo[] =>
      Array.isArray(val) &&
      val.every(
        (item) => isObject(item) && "status" in item && "videoUrl" in item
      )
  );

  $: videoSrc = videoInfoAssertion
    .typeSafeValue(
      getDataSourceValue({
        dataMap: $dataMap ?? {},
        keyString: "video",
      }),
      []
    )
    .find((video) => {
      if (image?.type === "IMAGE" && image.video?.fileName === video.filename) {
        return true;
      }
    });
</script>

<div
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
  style={styleToString(
    applyReducer(getFormImageVideoStyle(node), (style) => {
      // background로 비디오가 있을 경우, 비디오의 해상도로 aspectRatio를 조정
      if (isBackgroundVideo) {
        if (node.aspectRatio) {
          style.aspectRatio = getAspectRatioStyle({
            type: node.aspectRatio.type,
            imageHeight: videoSrc?.height,
            imageWidth: videoSrc?.width,
          });
        }

        style.background = "none";
      }

      return style;
    })
  )}
>
  {#if isBackgroundVideo}
    <BackgroundVideo fills={node.fills} {videoSrc} />
  {/if}
  <slot />
</div>
